import { Component, computed, inject } from '@angular/core';
import { SpinnerService } from './spinner.service';

@Component({
	selector: 'lib-shared-spinner',
	templateUrl: './spinner.component.html',
	imports: [],
	styleUrls: ['./spinner.component.scss']
})
export class LibSharedSpinnerComponent {
	private spinnerService = inject(SpinnerService);

	isLoading = computed(() => {
		return this.spinnerService.isLoading();
	});

	message = computed(() => this.spinnerService.message());
}
